<template>
  <table :class="{ 'tbl data': true, [className]: className }" v-if="!isMobile">
    <colgroup>
      <col v-for="(w, idx) in colgroup" :width="w" :key="idx" />
    </colgroup>
    <thead>
      <tr>
        <th v-for="(title, idx) in thead" :key="idx" class="text-ct">
          {{ title }}
        </th>
      </tr>
    </thead>
    <tbody>
      <template v-if="tbody.length > 0">
        <tr
          v-for="(row, idx) in tbody"
          :key="idx"
          @click="handleClick(row, idx)"
          class="cursor"
          :class="isboldCheck(idx)"
        >
          <td v-if="$slots.checkbox" class="text-ct">
            <slot name="checkbox" :row="row" :idx="idx"></slot>
          </td>
          <td
            v-for="(content, key, index) in row"
            :key="index"
            :class="{
              'text-ct': columnAlign[key] === 'center',
              'text-rt': columnAlign[key] === 'right',
            }"
          >
            <div class="layout">
              <svg-icon
                type="mdi"
                :path="pinPath"
                :width="18"
                :height="18"
                v-if="key == 'bbsNm' && ntcList.includes(idx)"
              ></svg-icon>
              <svg-icon
                type="mdi"
                :path="lockPath"
                :width="18"
                :height="18"
                v-if="key == 'bbsNm' && lockList.includes(idx)"
              ></svg-icon>
              <p v-if="htmlKeys.includes(key)" v-html="content"></p>
              <p v-else>{{ content }}</p>
            </div>
          </td>
          <td v-if="$slots.button" class="text-ct">
            <slot name="button" :row="row" :idx="idx"></slot>
          </td>
        </tr>
      </template>
      <tr v-else>
        <td :colspan="thead.length" class="text-ct data-none">
          등록된 정보가 존재하지 않습니다.
        </td>
      </tr>
    </tbody>
  </table>

  <!-- mobile-card -->
  <div v-else class="mobile-list">
    <div
      v-for="(row, idx) in tbody"
      :key="idx"
      class="mobile-item"
      @click="$emit('listClick', idx)"
    >
      <p class="title">
        {{ row.bbsNm }}
      </p>

      <div class="sub-info">
        <span class="writer">{{ row.wrtrNm }}</span>
        <span class="date">{{ row.wrtDt }}</span>
      </div>
    </div>
  </div>
  <!-- mobile-card -->
</template>

<script>
export default {
  props: {
    colgroup: {
      type: Array,
      default: [],
    },
    thead: {
      type: Array,
      default: [],
    },
    tbody: {
      type: Array,
      default: [],
    },
    className: {
      type: String,
      default: "",
    },
    ntcCnt: {
      type: Number,
      default: 0,
    },
    lockList: {
      type: Array,
      default: [],
    },
    ntcList: {
      type: Array,
      default: [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    // row 객체의 각 키를 'center' 또는 'right'로 지정하면 해당 컬럼을 가운데/오른쪽 정렬 (지정 없으면 왼쪽 정렬)
    columnAlign: {
      type: Object,
      default: () => ({}),
    },
    // 지정한 키의 셀은 HTML로 렌더 (색상 표시 등)
    htmlKeys: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // pinPath: mdiPin,
      // lockPath: mdiLock,
    };
  },
  methods: {
    handleClick: function (row, idx) {
      this.$emit("listClick", idx); // 'listClick' 이벤트 발생
    },
    isboldCheck(index) {
      return this.ntcList.includes(index) ? "contentBold" : "";
    },
  },
  watch: {},
  computed: {
    pinPath() {
      return this.$iconPath("mdiPin");
    },
    lockPath() {
      return this.$iconPath("mdiLock");
    },
  },
  components: {},
  mounted() {},
};
</script>
<style scoped>
.contentBold {
  font-weight: bold;
}

.lock-icon {
  width: 15px;
  height: 15px;
  margin-right: 5px;
  margin-left: 5px;
  display: inline-block;
  vertical-align: inherit;
}
</style>
